<div class="w-full px-2" [formGroup]="form">
  <div class="pt-3">
    <mat-form-field appearance="standard" class="w-full">
      <mat-label>Operator</mat-label>
      <mat-select
        class="ag-custom-component-popup"
        (selectionChange)="onOperatorChange($event.value)"
        formControlName="type"
      >
        <mat-option
          class="ag-custom-component-popup"
          *ngFor="let operator of operators; trackBy: trackByValue"
          [value]="operator.value"
        >
          {{ operator.text }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <y42-daterange-picker
    panelClass="ag-custom-component-popup"
    class="max-w-[300px]"
    [startDate]="form.controls.value.value"
    [endDate]="form.controls.value_between.value"
    [singleDatePicker]="form.controls.type.value !== 'inRange'"
    [timePicker]="state.hasTimePicker"
    (datesChanged)="setDates($event)"
  ></y42-daterange-picker>

  <div class="text-center py-2">
    <button mat-button color="primary" (click)="onFilterApply()" class="border-common" [disabled]="form.invalid">
      Apply
    </button>
    <button mat-button color="warn" class="ml-2 border-common" *ngIf="state.isFilterActive" (click)="onFilterReset()">
      Reset
    </button>
  </div>
</div>
